'use strict';

const GroupRoleRepository = require('common/domain/repository/group-role');
const GroupPermission = require('common/domain/entity/group-permission');
const MemberEditView = require('balus/ui/view/body/group/modal/member-edit/index');
const MemberAddView = require('balus/ui/view/body/group/modal/member-add/index');
const MemberItemView = require('balus/ui/view/body/group/sidebar/member-item');
const Template = require('balus/ui/template/body/group/sidebar/member-list.hbs');
const SubHeaderTemplate = require('balus/ui/template/body/group/sidebar/member-sub-header.hbs');
const ModalView = require('common/ui/view/modal/index');
const i18n = require('i18next');
const Mn = require('backbone.marionette');

const MemberListView = Mn.CollectionView.extend({
    tagName: 'table',
    className: 'list list-bordered member-list',
    childView: MemberItemView,

    childViewOptions: function() {
        return {
            groupRoles: this.getOption('groupRoles')
        }
    }
});

const ListSubHeaderView = Mn.View.extend({
    template: SubHeaderTemplate,

    initialize: function(params) {
        this._role = params.role;
    },

    templateContext: function() {
        const notSuspendedMembers = _.filter(this.collection.models, (member) => {return !member.get('suspended') });
        return {
            number: notSuspendedMembers.length,
            role: this._role
        };
    }
});

module.exports = Mn.View.extend({
    template: Template,
    ui: {
        editButton: '.edit',
        addButton: '.add'
    },
    events: {
        'click @ui.editButton': 'edit',
        'click @ui.addButton': 'add'
    },
    modelEvents: {
        change: 'render'
    },
    regions: {
        adminHeader: '.admin-sub-header-wrapper',
        adminList: '.admin-list-wrapper',
        memberHeader: '.member-sub-header-wrapper',
        memberList: '.member-list-wrapper',
        guestHeader: '.guest-sub-header-wrapper',
        guestList: '.guest-list-wrapper'
    },

    templateContext: function() {
        const context = this.getOption('context');
        const groupRole = context.getGroupRole();
        const notSuspendedMembers = _.filter(this.collection.models, (member) => {return !member.get('suspended') });

        const loginUser = context.getUser();
        const isProduction = context.getAppInfo().isProduction();
        let canAddMember = false;
        if (!isProduction) {
            canAddMember = true;
        }
        if (isProduction && loginUser && loginUser.isSiteAdmin()) {
            // 本番環境ではサイト管理者のみグループへのメンバー追加を行える
            // サイト管理者以外は、メールアドレスを使ったメンバー招待機能を利用する想定。
            canAddMember = true;
        }

        return {
            groupMemberNumber: notSuspendedMembers.length,
            canAddMember: canAddMember,
            canEditMember: groupRole.getPermission(GroupPermission.GroupEditPermission).isPermitted(context)
        };
    },

    onRender: function() {
        const groupedMembers = _.groupBy(this.collection.models, (member) =>{ return member.get('role') });
        const admins = new Backbone.Collection(groupedMembers['admin']);
        const members = new Backbone.Collection(groupedMembers['member']);
        const guests = new Backbone.Collection(groupedMembers['guest']);

        GroupRoleRepository.find(this.model).fetchRoles()
            .then(groupRoles => {
                this.showChildView('adminHeader', new ListSubHeaderView({
                    collection: admins,
                    role: i18n.t('group-role.admin')
                }));
                this.showChildView('adminList', new MemberListView({
                    collection: admins,
                    groupRoles: groupRoles
                }));
                this.showChildView('memberHeader', new ListSubHeaderView({
                    collection: members,
                    role: i18n.t('group-role.member')
                }));
                this.showChildView('memberList', new MemberListView({
                    collection: members,
                    groupRoles: groupRoles
                }));
                this.showChildView('guestHeader', new ListSubHeaderView({
                    collection: guests,
                    role: i18n.t('group-role.guest')
                }));
                this.showChildView('guestList', new MemberListView({
                    collection: guests,
                    groupRoles: groupRoles
                }));
            });
    },

    edit: function() {
        const modal = new ModalView({
            title: i18n.t('title.group.member.edit'),
            bodyView: new MemberEditView({
                context: this.getOption('context'),
                model: this.model,
                collection: this.collection
            }),
            onChildviewSave: function() {
                this.disableButtons();
                this.getOption('bodyView').save()
                    .then(() => {
                        this.hide();
                        location.reload();
                    })
                    .catch(() => {
                        this.enableButtons();
                    })
            }
        });
        modal.show();
    },

    add: function() {
        const modal = new ModalView({
            title: i18n.t('title.group.member.add'),
            bodyView: new MemberAddView({
                context: this.getOption('context'),
                model: this.model,
                collection: this.collection
            }),
            onChildviewSave: function() {
                this.disableButtons();
                this.getOption('bodyView').save()
                    .then(() => {
                        this.hide();
                        location.reload();
                    })
                    .catch(() => {
                        this.enableButtons();
                    })
            }
        });
        modal.show();
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/group/sidebar/member-list.js